<div class="container text-center text-grey">
  <h1 class="Error404">404</h1>
  <h1>Opps! The page you requested wasn't found.</h1>
  <h3>Redirecting to Jobs in <span style="color: red;">{{count}}</span> seconds.</h3>
</div>